export const getGlobalRepairServices = state => state.globalRepair;



// WEBPACK FOOTER //
// ./src/store/reducers/globalRepair/selectors.js